import { render } from "./TablePanel.vue?vue&type=template&id=d229a45e&scoped=true&ts=true&lang=pug"
import script from "./TablePanel.vue?vue&type=script&lang=ts"
export * from "./TablePanel.vue?vue&type=script&lang=ts"

import "./TablePanel.vue?vue&type=style&index=0&id=d229a45e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d229a45e"]])

export default __exports__